import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import { API_BASE_URL } from '@config';

export const SET_OPENID_CONFIGS = 'SET_OPENID_CONFIGS';
export const SET_OPENID_ERROR = 'SET_OPENID_ERROR';

export const setOpenIdConfigs = (data) => ({
  type: SET_OPENID_CONFIGS,
  payload: data,
});

export const setOpenIdError = (data) => ({
  type: SET_OPENID_ERROR,
  payload: data,
});

export const getOpenIdConfigs = (organizationId) => (dispatch) => {
  let url = `${API_BASE_URL}/api/openid-config`;
  if (organizationId !== undefined && organizationId !== null) {
    url += `?organizationId=${organizationId}`;
  }
  return axios
    .get(url)
    .then((response) => {
      dispatch(setOpenIdConfigs(response.data));
    })
    .catch((err) => {
      dispatch(setOpenIdError({ ...err.response, type: 'modal' }));
    });
};

export const updateOpenIdConfig = (config, organizationId) => (dispatch) => {
  if (config.clientSecret === '') delete config.clientSecret;
  const url = `${API_BASE_URL}/api/openid-config/${config.id}`;
  return axios
    .patch(url, config)
    .then(() => {
      dispatch(showMessage({ message: 'OpenID Config Updated Successfully' }));
      dispatch(getOpenIdConfigs(organizationId));
    })
    .catch((err) => {
      dispatch(setOpenIdError({ ...err.response, type: 'modal' }));
    });
};

export const addOpenIdConfig = (config, organizationId) => (dispatch) => {
  const payload = { ...config };
  if (organizationId !== undefined && organizationId !== null) {
    payload.organizationId = organizationId;
  }
  const url = `${API_BASE_URL}/api/openid-config`;
  return axios
    .post(url, payload)
    .then(() => {
      dispatch(showMessage({ message: 'OpenID Config Added Successfully' }));
      dispatch(getOpenIdConfigs(organizationId));
    })
    .catch((err) => {
      dispatch(setOpenIdError({ ...err.response, type: 'modal' }));
    });
};

export const deleteOpenIdConfig = (id, organizationId) => (dispatch) => {
  const url = `${API_BASE_URL}/api/openid-config/${id}`;
  return axios
    .delete(url)
    .then(() => {
      dispatch(showMessage({ message: 'OpenID Config Deleted Successfully' }));
      dispatch(getOpenIdConfigs(organizationId));
    })
    .catch((err) => {
      dispatch(setOpenIdError({ ...err.response, type: 'modal' }));
    });
};
